export const scalingAgileModule = {
  id: "scaling-agile-enterprise",
  title: "Scaling Agile for Enterprise Organizations", 
  description: "Learn frameworks and practices for scaling Agile methodologies across large enterprise organizations with multiple teams.",
  content: `
## What You'll Learn
By the end of this module, you will be able to:
- Apply scaling frameworks like SAFe, LeSS, and Scrum@Scale to enterprise environments
- Coordinate multiple Agile teams working on related products
- Implement portfolio-level Agile planning and governance
- Manage dependencies and alignment across scaled Agile initiatives

## Prerequisites
- Solid understanding of Scrum and Agile principles
- Experience with single-team Agile implementation
- Knowledge of enterprise organizational structures

## Overview
92% of organizations practice Agile, but only 26% scale it successfully across the enterprise. This module covers proven frameworks and practices for scaling Agile to hundreds of teams and thousands of practitioners.

---

## Key Concepts

### Scaling Frameworks

#### Scaled Agile Framework (SAFe)
**Program Level**: Agile Release Trains coordinate 5-12 teams
**Large Solution Level**: Multiple ARTs for complex solutions
**Portfolio Level**: Strategic themes and epic prioritization
**Team Level**: Standard Scrum/Kanban practices

#### Large-Scale Scrum (LeSS)
**LeSS Framework**: 2-8 teams working on one product
**LeSS Huge**: 8+ teams with area product owners
**Single Product Owner**: Maintains overall product vision
**Coordinated Sprints**: All teams work in same sprint cadence

### Enterprise Agile Governance

#### Portfolio Kanban
**Epic Hypothesis**: Large initiatives requiring multiple teams
**Investment Funding**: Lean portfolio management approach
**Metrics-Driven**: Measure outcomes, not just outputs
**Value Stream Mapping**: Identify and optimize flow

#### Objectives and Key Results (OKRs)
**Quarterly Objectives**: Ambitious goals for 3-month periods
**Measurable Key Results**: Specific metrics to track progress
**Cascading Alignment**: Enterprise to team-level OKRs
**Regular Check-ins**: Monthly progress reviews and adjustments

---

## Assessment

This module prepares leaders to successfully scale Agile practices across large enterprise organizations.
`,
  duration: 75
};